<div class="signuplogin">
  <nav class="navbar" (clickOutside)="closeNav()">
    <div id="mySidebar" class="sidebar">
      <a class="margintp pt-0 handsymbol" (click)="closeNav()"
        ><img src="assets/images/close-charcoal.svg" width="18"
      /></a>
      <a class="optn handsymbol" 
      href="{{aap_url}}"
      href="javascript:void(0)"
        ><span>Home</span>
        <img src="assets/images/home-charcoal.svg" class="float-right optn"
      /></a>
      <a class="optn handsymbol"  href="{{aap_url}}/faq"
        ><span>FAQ</span>
        <img src="assets/images/faq-charcoal.svg" class="float-right"
      /></a>
      <a class="optn handsymbol" href="{{aap_url}}/blog"
        ><span>Blog</span>
        <img src="assets/images/blog-charcoal.svg" class="float-right"
      /></a>
      <a class="optn handsymbol"   href="{{aap_url}}/giveback"
        ><span>Giveback</span>
        <img src="assets/images/giveback-charcoal.svg" class="float-right"
      /></a>
      <a
        class="optn handsymbol"
        *ngIf="iconshow"
        (click)="headerMenu('startover')"
        >Start Over
        <img src="assets/images/startover-charcoal.svg" class="float-right"
      /></a>
      <a
        class="optn handsymbol"
        *ngIf="iconshow"
        href="{{aap_url}}/faq/contact-us"
        >Contact Us
        <img src="assets/images/contactus-charcoal.svg" class="float-right"
      /></a>

      <a class="optn handsymbol" *ngIf="!showLogin" (click)="gotoProfile()"
        >Profile
        <img src="assets/images/profile-icon-black.svg" class="float-right"
      /></a>

      <a class="optn handsymbol" *ngIf="!showLogin" (click)="gotologout()"
        >Logout
        <img src="assets/images/logout-icon-black.svg" class="float-right"
      /></a>

      <div class="sidebar-ftr">
        <ul class="list-inline mb-5">
          <li>
            <a
              href="https://www.facebook.com/honestgorilla1/"
              class="px-0"
              target="_blank"
              ><img src="assets/images/facebook-co.svg" width="48px"
            /></a>
          </li>
          <li>
            <a
              href="https://twitter.com/honestgorilla"
              class="px-0"
              target="_blank"
              ><img src="assets/images/twitter-co.svg" width="48px"
            /></a>
          </li>
          <li>
            <a
              href="https://www.instagram.com/honestgorilla_energy/ "
              class="px-0"
              target="_blank"
              ><img src="assets/images/instragram-co.svg" width="48px"
            /></a>
          </li>
        </ul>
      </div>
    </div>
    <div id="main" class="w-100">
      <button class="openbtn" id="hideprocess" (click)="openNav($event)">
        <img src="assets/images/list-charcoal.png" width="15" />
      </button>
      <a
        class="navbar-brand logomain mt-2"
        id="hidetxt"
        (click)="openNav($event)"
        ><img
          src="assets/images/logotxt-charcoal.svg"
          height="33"
          class="logo ml-3 logotextClick" /><img
          src="assets/images/logotxt-charcoal.svg"
          width="150"
          class="logo1 sectpad logotextClick"
      /></a>
      <a
        *ngIf="iconshow"
        class="float-right text-center ml-1 mt-1 wd60 webview handsymbol"
        data-toggle="modal"
        data-target="#contactModal"
        (click)="showModal()"
        ><img src="assets/images/help.png" />
        <font class="disblk clr333 quesnavtxt handsymbol">Help</font>
      </a>
      <a
        *ngIf="iconshow"
        class="float-right text-center ml-1 mt-1 wd60 webview handsymbol"
        (click)="startOver()"
        ><img src="assets/images/startovergry.png" />
        <font class="disblk clr333 quesnavtxt handsymbol">Start Over</font>
      </a>
    </div>
    <!-- <app-contactus [mVisible]="modalVisible" (closeModalEvent)="onClose($event)"></app-contactus> -->
  </nav>
  <app-contactus
    [mVisible]="modalVisible"
    (closeModalEvent)="onClose($event)"
  ></app-contactus>
</div>
